
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M99.939 6c51.874 0 93.924 42.057 93.924 93.939 0 51.867-42.05 93.924-93.924 93.924C48.07 193.863 6 151.806 6 99.939 6 48.057 48.071 6 99.939 6zm4.803 55.677c-5.986.043-11.936.101-17.915.152-2.395.036-4.797.073-7.184.167-4.941.189-9.876.392-14.802.653-1.981.094-3.984.247-5.943.653-4.035.806-7.25 2.946-9.26 6.661-1.414 2.62-2.212 5.479-2.582 8.432-.407 3.106-.639 6.211-.871 9.332-.436 6.755-.298 13.532-.203 20.317.087 3.868.508 7.735.747 11.595.196 2.99.827 5.892 1.821 8.722 1.531 4.52 4.608 7.467 9.238 8.671 1.988.501 4.034.82 6.08 1.01 3.287.268 6.603.413 9.898.543 3.962.153 7.945.247 11.907.327 5.101.087 10.195.138 15.978.247 3.483-.051 7.641-.124 11.806-.182l3.213-.05c1.605-.027 3.21-.065 4.812-.139 5.087-.16 10.166-.355 15.231-.624 2.09-.116 4.194-.26 6.233-.674 4.26-.82 7.554-3.077 9.571-7.01a24.204 24.204 0 002.402-8.105c.42-3.461.755-6.93.87-10.398.182-6.436.24-12.873.182-19.302-.05-3.838-.457-7.691-.733-11.537-.203-2.873-.79-5.653-1.69-8.374-1.343-4.07-3.904-7.016-7.866-8.693-2.119-.907-4.39-1.204-6.661-1.306-5.37-.297-10.725-.53-16.08-.754-3.091-.124-6.175-.167-9.266-.225-2.975-.037-5.965-.11-8.933-.11zM89.647 83.769c9.905 5.16 19.737 10.304 29.707 15.514-9.963 5.13-19.802 10.246-29.707 15.39z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    